import { ASTEROP_BASE_URL, ASTEROP_API_KEY, MAP_URL_BY_TYPE, DATA_URL_BY_TYPE, getGeoJsonUrl, getQueryString } from '@/services/asterop/getUrl';
import HTTP from '../HTTPAsterop';

export async function getBasicData(location, isochrone) {
  try {
    const queryItems = getQueryString('json', location, isochrone);
    const url = ASTEROP_BASE_URL +
      '/dashboards/{0A9A2F88-E059-4B9D-96F1-8F4C59D41F7C}/views/{69E811D4-7988-44B8-81D8-5A15DE1D3499}';
    const response = await HTTP.get(url, { params: queryItems });
    return response;
  } catch (e) {
    throw e;
  }
}

export async function getDataTable(type, location, isochrone) {
  try {
    const queryItems = getQueryString('json', location, isochrone);
    const url = ASTEROP_BASE_URL +
    DATA_URL_BY_TYPE[type];
    const response = await HTTP.get(url, { params: queryItems });
    return response;
  } catch (e) {
    throw e;
  }
}

export async function getMapMetadata(type, location, isochrone) {
  try {
    const queryItems = getQueryString('json', location, isochrone);
    delete queryItems.context;
    delete queryItems.sites;
    const url = ASTEROP_BASE_URL +
      MAP_URL_BY_TYPE[type];
    const response = await HTTP.get(url, { params: queryItems });
    return response;
  } catch (e) {
    throw e;
  }
}

export async function getMapData(type, location, isochrone, layer) {
  try {
    const queryItems = getQueryString('json', location, isochrone);
    const url = ASTEROP_BASE_URL +
      MAP_URL_BY_TYPE[type] + '/layers/' + layer;
    const response = await HTTP.get(url, { params: queryItems });
    return response;
  } catch (e) {
    throw e;
  }
}

export async function getMapGeoJson(type, location, isochrone) {
  try {
    const url = getGeoJsonUrl(type, location, isochrone);
    const response = await HTTP.get(url);
    return response;
  } catch (e) {
    throw e;
  }
}


export async function getLSA(insee) {
  try {
    const url = ASTEROP_BASE_URL + '/lsa/stores';
    const queryItems = {
      key: ASTEROP_API_KEY,
      filter: JSON.stringify({
        commune: [insee],
      }),
    };
    const response = await HTTP.get(url, { params: queryItems });
    return response;
  } catch (e) {
    throw e;
  }
}

export async function getSymbols() {
  try {
    const url = ASTEROP_BASE_URL + '/globals/symbols';
    const queryItems = {
      f: 'json',
      key: ASTEROP_API_KEY,
    };
    const response = await HTTP.get(url, { params: queryItems });
    return response;
  } catch (e) {
    throw e;
  }
}




// WEBPACK FOOTER //
// ./src/api/asterop/index.js